export default "__VITE_ASSET__CSbLKeMu__"